(function () {
  var root = document.getElementById('CollectionSection');
  if (!root) return;

  var collectionHandle = root.getAttribute('data-collection-handle');
  if (!collectionHandle) return;

  var country = root.getAttribute('data-country') || '';
  var currency = root.getAttribute('data-currency') || '';
  var PAGE_SIZE = 250;
  var MAX_PAGES = 5;

  var priceMapPromise = null;
  var timer = null;
  var observer = null;

  function formatMoney(value) {
    var amount = Number(value);
    if (!isFinite(amount)) return '';
    if (currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (e) {
      }
    }
    return String(value);
  }

  function fetchPage(page) {
    var url =
      '/collections/' + collectionHandle + '/products.json?limit=' + PAGE_SIZE + '&page=' + page;
    if (country) url += '&country=' + encodeURIComponent(country);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function getPriceMap() {
    if (priceMapPromise) return priceMapPromise;

    var map = {};
    var load = function (page) {
      return fetchPage(page).then(function (json) {
        var products = (json && json.products) || [];
        products.forEach(function (product) {
          var variant = product.variants && product.variants[0];
          if (variant) map[product.handle] = variant.price;
        });
        if (products.length === PAGE_SIZE && page < MAX_PAGES) return load(page + 1);
        return map;
      });
    };

    priceMapPromise = load(1).catch(function () {
      return map;
    });
    return priceMapPromise;
  }

  function render(map) {
    var items = root.querySelectorAll('.collection-list-item[data-product-handle]');
    Array.prototype.forEach.call(items, function (item) {
      var target = item.querySelector('.grid-product__price');
      if (!target) return;

      var price = map[item.getAttribute('data-product-handle')];
      if (price === undefined || price === null) {
        target.classList.add('visually-hidden');
        return;
      }

      var text = formatMoney(price);
      if (target.textContent !== text) target.textContent = text;
      target.classList.remove('visually-hidden');
    });
  }

  function hydrate() {
    getPriceMap().then(function (map) {
      if (observer) observer.disconnect();
      render(map);
      observe();
    });
  }

  function observe() {
    if (!observer) return;
    observer.observe(root, { childList: true, subtree: true });
  }

  observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(hydrate, 80);
  });

  hydrate();
})();
